import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.car-info',
    method: 'get',
    params,
  })
}

export const listAllByDirector = (params?: any) => {
  return axiosService({
    url: '/api.car-info/all',
    method: 'get',
    params,
  })
}

export const listByCustomer = (params?: any) => {
  return axiosService({
    url: '/api.car-info/customer',
    method: 'get',
    params,
  })
}

export const getLastCarInfo = (params: any) => {
  return axiosService({
    url: '/api.car-info/last',
    method: 'get',
    params,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.car-info/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.car-info/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.car-info/${id}`,
    method: 'put',
    data,
  })
}

export const reject = (id: number, data: any) => {
  return axiosService({
    url: `/api.car-info/${id}/reject`,
    method: 'put',
    data,
  })
}

export const remake = (id: number, data: any) => {
  return axiosService({
    url: `/api.car-info/${id}/remake`,
    method: 'put',
    data,
  })
}

export const approve = (id: number, data: any) => {
  return axiosService({
    url: `/api.car-info/${id}/approve`,
    method: 'put',
    data,
  })
}

export const reApprove = (id: number, data: any) => {
  return axiosService({
    url: `/api.car-info/${id}/re-approve`,
    method: 'put',
    data,
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.car-info/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.request/buy',
    method: 'post',
    data,
  })
}

export const createCarInfo = (data: any) => {
  return axiosService({
    url: '/api.car-info',
    method: 'post',
    data,
  })
}

export const updateCarInfo = (id: number, data: any) => {
  return axiosService({
    url: `/api.car-info/${id}`,
    method: 'put',
    data,
  })
}
